var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#ffffff","height":"100%"}},[_c('div',{ref:"fixd",attrs:{"id":"WangEditor"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }